import React from "react";
import {
  Grid,
  CircularProgress,
  IconButton,
  Badge,
  Typography,
} from "@material-ui/core";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import _ from "lodash";
import { useQuery } from "@apollo/react-hooks";
import { QUESTIONS, REFERENCE } from "./queries";
import { useStyles } from "./styles";
import CommentsDrawer from "./CommentsDrawer";
import SummaryPanel from "./SummaryPanel";
import ChoiceInfoDrawer from "./ChoiceInfoDrawer/ChoiceInfoDrawer";
// import InfiniteScroll from 'react-infinite-scroller'

const COLOR_BY_DIMENSION = {
  Ambiental: "#6ca14d",
  "Ambiental IF": "#78dea7",
  "Econômico-Financeira": "#b284cf",
  Geral: "#e866c3",
  "Governança Corporativa": "#439dd1",
  "Mudança do Clima": "#f7d288",
  "Natureza do Produto": "#ccb350",
  Social: "#495f9c",
};

function QuestionsScreen(props) {
  if (!props.surveyId) return null;

  const noMatchedSubtopicColor = "#ddd";
  const noSubtopicColor = "#ddd";
  const remainingColor = "white";

  const classes = useStyles();
  const currentUserId = localStorage.getItem("userId");
  const isStandard = props.visualizationType === "standard";
  const isNewModel = props.visualizationType === "newModel";
  const [currentSelectedQuestionId, setCurrentSelectedQuestionId] =
    React.useState();
  const [currentSelectedQuestionData, setCurrentSelectedQuestionData] =
    React.useState();
  const [currentSelectedChoiceId, setCurrentSelectedChoiceId] =
    React.useState();

  const { hasReference } = props;
  // const [limit, setLimit] = React.useState(5)
  // const [offset, setOffset] = React.useState(0)

  const handleOpenCommentDrawer = (question, dimensionAbbreviation, _event) => {
    setCurrentSelectedQuestionId(question.id);
    setCurrentSelectedQuestionData({ ...question, dimensionAbbreviation });
  };

  const handleOpenChoiceInfoDrawer = (choice, _event) => {
    setCurrentSelectedChoiceId(choice.id);
  };

  const handleCloseCommentDrawer = () => {
    setCurrentSelectedQuestionId(false);
  };

  const handleCloseChoiceInfoDrawer = () => {
    setCurrentSelectedChoiceId(false);
  };

  const subtopicsForCurrentSector = [
    ...new Set(
      props.subtopicsPerSectors
        .filter((subtopicPerSector) =>
          !!props.sectorId
            ? subtopicPerSector.sectorId === props.sectorId
            : true,
        )
        .map((subtopicPerSector) => subtopicPerSector.tagId),
    ),
  ];

  const { loading, error, data, fetchMore } = useQuery(
    hasReference ? QUESTIONS : REFERENCE,
    {
      variables: {
        surveyId: props.surveyId,
        dimensionId: isStandard ? props.dimensionId : null,
        sectorId: isNewModel ? props.sectorId : 0,
        groupId: isNewModel ? props.groupId : null,
        subtopicId: isNewModel ? props.subtopicId : null,
        topicId: isNewModel && !props.subtopicId ? props.topicId : null,
        // limit: limit,
        // offset: offset,
      },
      fetchPolicy: "cache-and-network",
    },
  );

  if (error) return <p>{error.message}</p>;

  if (loading) {
    return (
      <Grid container item justify="center">
        <CircularProgress />
      </Grid>
    );
  }

  const filterChoices = (choices) => {
    const allowedId = !!props.subtopicId ? props.subtopicId : props.topicId;

    // For standard visualization we will show all table columns
    return choices.filter(
      (choice) => isStandard || choice.tags.find((tag) => allowedId === tag.id),
    );
  };

  const makeMatrixChoices = (question, dimensionName) => {
    const allowedChoices = filterChoices(question.choices);
    const questionHeader = [
      ...new Set(allowedChoices.map((choice) => choice.colText)),
    ];
    const questionRows = _.uniqBy(allowedChoices, "rowText");
    const isSimpleMatrix = question.questionType === "simple_matrix";

    return (
      <div key={question.id} className={classes.questionWrapper}>
        <table className={classes.questionTable}>
          <thead>
            <tr>
              <th className={classes.choiceTextHeaderCell}></th>
              {questionHeader.map((option) => (
                <th
                  style={{ color: COLOR_BY_DIMENSION[dimensionName] }}
                  className={classes.questionTableHeaderCell}
                >
                  {option.replace(/^\s*(\d+).\d+\s*$/, (_, p1) =>
                    p1 === "1" ? "100%" : `${p1}%`,
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {questionRows.map((choice) => {
              const choiceTagIds = choice.tags
                .filter(
                  (tag) => tag.type === "topic" || tag.type === "subtopic",
                )
                .map((tag) => tag.id);

              const subtopicsForThisChoice = subtopicsForCurrentSector.filter(
                (subtopic) => choiceTagIds.includes(subtopic),
              );
              const highlightOrHideChoice = _.isEmpty(subtopicsForThisChoice);

              if (isNewModel && highlightOrHideChoice) return null;
              if (
                (isNewModel &&
                  !props.subtopicId &&
                  !!props.topicId &&
                  !choiceTagIds.includes(props.topicId)) ||
                (!!props.subtopicId && !choiceTagIds.includes(props.subtopicId))
              )
                return null;

              const choiceBgColor = !!props.sectorId
                ? highlightOrHideChoice && noMatchedSubtopicColor
                : !choiceTagIds.length && noSubtopicColor;

              return (
                <tr
                  className={classes.choice}
                  style={{
                    backgroundColor:
                      choiceBgColor || (isStandard && remainingColor),
                  }}
                  key={choice.id}
                  onClick={(event) => handleOpenChoiceInfoDrawer(choice, event)}
                >
                  <td className={classes.questionTableRowCell}>
                    {/* ID da alternativa { choice.id }
                      IDs das tags: { choiceTagIds.join(', ') }
                      { ' - ' }
                      Subtopics encontrados: { subtopicsForThisChoice.join(', ') } */}
                    {choice.rowText.split("|").map((e) => {
                      if (e) {
                        return e;
                      } else {
                        return (
                          <div
                            style={{
                              display: "inline",
                              paddingLeft: "10px",
                            }}
                          />
                        );
                      }
                    })}
                  </td>
                  {questionHeader.map((_option) => (
                    <td className={classes.questionTableCell}>
                      {isSimpleMatrix ? (
                        <input type="radio" name={choice.id} />
                      ) : (
                        <input type="checkbox" />
                      )}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  const makeChoices = (question) => {
    return (
      <div key={question.id} className={classes.questionWrapper}>
        {question.choices.map((choice) => {
          const choiceTagIds = choice.tags
            .filter((tag) => tag.type === "topic" || tag.type === "subtopic")
            .map((tag) => tag.id);

          const subtopicsForThisChoice = subtopicsForCurrentSector.filter(
            (subtopic) => choiceTagIds.includes(subtopic),
          );
          const highlightOrHideChoice = _.isEmpty(subtopicsForThisChoice);

          if (isNewModel && highlightOrHideChoice) return null;
          if (
            (isNewModel &&
              !props.subtopicId &&
              !!props.topicId &&
              !choiceTagIds.includes(props.topicId)) ||
            (!!props.subtopicId && !choiceTagIds.includes(props.subtopicId))
          )
            return null;

          const choiceBgColor = !!props.sectorId
            ? highlightOrHideChoice && noMatchedSubtopicColor
            : !choiceTagIds.length && noSubtopicColor;

          return (
            <p
              className={classes.choice}
              style={{
                backgroundColor:
                  choiceBgColor || (isStandard && remainingColor),
              }}
              key={choice.id}
              onClick={(event) => handleOpenChoiceInfoDrawer(choice, event)}
            >
              {choice.rowText.split("|").map((e) => {
                if (e) {
                  return e;
                } else {
                  return (
                    <div
                      style={{
                        display: "inline",
                        paddingLeft: "10px",
                      }}
                    />
                  );
                }
              })}
              {/* &#8226; IDs das tags: { choiceTagIds.join(', ') } - Subtopics encontrados: { subtopicsForThisChoice.join(', ') } */}
            </p>
          );
        })}
      </div>
    );
  };

  const makeQuestion = (question) => {
    const dimension = question.tags.find((tag) => tag.type === "dimension");

    const dimensionName = dimension.name;
    const dimensionAbbreviation = dimension.abbreviation;

    const commentsCount =
      props.userProfile === "administrator"
        ? question.comments.filter((c) => c.status === "approved").length
        : question.comments.filter(
            (c) =>
              c.userId == currentUserId ||
              (c.status === "approved" && !c.isPrivate),
          ).length;

    return (
      <div key={question.id} className={classes.question}>
        <IconButton
          color="inherit"
          aria-label="comments"
          component="span"
          className={classes.statement}
          classes={{ root: classes.iconButtonRoot }}
          onClick={(event) =>
            handleOpenCommentDrawer(question, dimensionAbbreviation, event)
          }
        >
          <Badge badgeContent={commentsCount} color="secondary">
            <QuestionAnswerIcon fontSize="small" />
          </Badge>
          <span style={{ marginLeft: "1rem" }}>
            {/* <span style={{ color: COLOR_BY_DIMENSION[dimensionName] }}>
              { `${dimensionAbbreviation} ` }
            </span> */}
            {/* { question.hierarchy } -  */}
            {question.statement.split("\n").map((line, index) => {
              return [index !== 0 ? <br></br> : null, line];
            })}
          </span>
        </IconButton>
        {question.protocols && (
          <span className={classes.protocols}>{question.protocols}</span>
        )}
        {question.references && (
          <span className={classes.references}>{question.references}</span>
        )}
        {question.questionType.includes("matrix")
          ? makeMatrixChoices(question, dimensionName)
          : makeChoices(question)}
        {question.documents && (
          <span className={classes.documents}>{question.documents}</span>
        )}
      </div>
    );
  };

  const groupQuestionsBy = (questions, tagType) => {
    const comparisonFunction = (question) =>
      question.tags.find((tag) => tag.type === tagType).name;
    const questionsGrouped = _.groupBy(questions, comparisonFunction);
    const typesSorted = [...new Set(Object.keys(questionsGrouped))].sort();

    return [questionsGrouped, typesSorted];
  };

  const makeStandardQuestions = (questions) => {
    const [groupedByDimension, dimensions] = groupQuestionsBy(
      questions,
      "dimension",
    );

    return (
      <>
        {dimensions.map((dimension) => {
          const [groupedByCriterion, criterions] = groupQuestionsBy(
            groupedByDimension[dimension],
            "criterion",
          );

          return (
            <div key={dimension}>
              <p className={classes.dimensionGroup}>
                <span style={{ color: COLOR_BY_DIMENSION[dimension] }}>
                  {dimension}
                </span>
              </p>
              {criterions.map((criterion) => {
                const [groupedByIndicator, indicators] = groupQuestionsBy(
                  groupedByCriterion[criterion],
                  "indicator",
                );

                return (
                  <>
                    <p id={criterion} className={classes.criterionGroup}>
                      {criterion.split("–", 2)[0]}
                      {" – "}
                      <span style={{ color: COLOR_BY_DIMENSION[dimension] }}>
                        {criterion.split("–", 2)[1]}
                      </span>
                    </p>
                    {indicators
                      .sort((a, b) => {
                        const aLevel = a.match(/(\d+)/);
                        const bLevel = b.match(/(\d+)/);

                        if (!aLevel || !bLevel) return true;

                        return aLevel[0] - bLevel[0];
                      })
                      .map((indicator) => (
                        <>
                          <p id={indicator} className={classes.indicatorGroup}>
                            {indicator.split(".", 2)[0]}
                            {". "}
                            <span
                              style={{ color: COLOR_BY_DIMENSION[dimension] }}
                            >
                              {indicator.split(".", 2)[1]}
                            </span>
                          </p>
                          {groupedByIndicator[indicator].map(makeQuestion)}
                        </>
                      ))}
                  </>
                );
              })}
            </div>
          );
        })}
      </>
    );
  };

  const makeNewModelQuestions = (questions) => {
    const [groupedByDimension, dimensions] = groupQuestionsBy(
      questions,
      "dimension",
    );

    return (
      <>
        {dimensions.map((dimension) => (
          <div key={dimension}>
            <p className={classes.dimensionGroup}>
              <span style={{ color: COLOR_BY_DIMENSION[dimension] }}>
                {dimension}
              </span>
            </p>

            {groupedByDimension[dimension].map(makeQuestion)}
          </div>
        ))}
      </>
    );
  };

  // const handleInfiniteScroll = () => {
  //   setOffset(limit)
  //   setLimit(limit + 5)

  //   return new Promise(() => fetchMore({
  //     variables: {
  //       limit: limit,
  //       offset: offset,
  //     },
  //     updateQuery: (previousResult, { fetchMoreResult }) => {
  //       console.log(fetchMoreResult)
  //       return isStandard
  //         ? makeStandardQuestions(fetchMoreResult)
  //         : makeNewModelQuestions(fetchMoreResult)
  //     }
  //   }))
  // }

  return (
    <>
      {isStandard && <SummaryPanel questions={data.filteredQuestions} />}

      <CommentsDrawer
        closeDialog={handleCloseCommentDrawer}
        questionId={currentSelectedQuestionId}
        questionData={currentSelectedQuestionData}
      />

      <ChoiceInfoDrawer
        closeDialog={handleCloseChoiceInfoDrawer}
        choiceId={currentSelectedChoiceId}
      />

      {isNewModel && _.isEmpty(data.filteredQuestions) && (
        <Grid container justify="center">
          <Grid item xs={6}>
            <Typography align="center" className={classes.noQuestionsFound}>
              Não há perguntas relacionadas a este tema no(s) setor(s)
              selecionado(s).
            </Typography>
          </Grid>
        </Grid>
      )}

      {/* <InfiniteScroll
        pageStart={ 0 }
        loadMore={ handleInfiniteScroll }
        hasMore={ !_.isEmpty(data) }
        loader={
          <Grid container item justify="center">
            <CircularProgress />
          </Grid>
        }
      > */}
      {isStandard
        ? makeStandardQuestions(data.filteredQuestions)
        : makeNewModelQuestions(data.filteredQuestions)}
      {/* </InfiniteScroll> */}
    </>
  );
}

export default QuestionsScreen;
